import React from 'react'
import BaseCard from '../molecules/BaseCard'
import RevealOnScroll from '../atoms/RevealOnScroll'
import styles from './FeaturesGrid.module.css'

import icon1 from '../../assets/images/s1-icon-1.svg'
import icon2 from '../../assets/images/s1-icon-2.svg'
import icon3 from '../../assets/images/s1-icon-3.svg'
import icon4 from '../../assets/images/s1-icon-4.svg'

const features = [
    { id: 1, text: 'All credit types considered', icon: icon1 },
    { id: 2, text: 'Absolutely no hidden fees', icon: icon2 },
    { id: 3, text: 'Fast and secure process', icon: icon3 },
    { id: 4, text: 'Connect with top US lenders', icon: icon4 }
]

export const FeaturesGrid = () => {
    return (
        <section className={styles.featuresSection}>
            <div className={styles.contentContainer}>
                <h2 className={styles.sectionTitle}>
                    We’ve helped over 2M+ people get the loans they need, with 7K+ successful connections every week with:
                </h2>

                <div className={styles.featuresGrid}>
                    {features.map((feature, index) => (
                        <RevealOnScroll
                            key={feature.id}
                            delay={index * 100}
                            threshold={0.2}
                            animation="reveal-up"
                        >
                            <BaseCard
                                title={feature.text}
                                iconSrc={feature.icon}
                            />
                        </RevealOnScroll>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FeaturesGrid
